module.exports = __webpack_public_path__ + "static/media/largeClock.571d03e7.svg";